export default __webpack_public_path__ + "static/media/P30007.1d95ff08.png";